module.exports = __webpack_public_path__ + "static/media/Children Illustrator ID.2dcea930.png";